import type { MosObjCompatibleItem } from '@mimir/common/mos/mos-interfaces';
import type { State } from '@mimir/web/store/state';
import type { Store } from 'vuex';
import type { MetaDataSchema } from '@mimir/common/mdf/metadataSchema';
import { SystemDefaultField } from '@mimir/common/mdf/mdfDefaults';
import { getItemSystemDefaultField, replaceIdWithFieldIdForSchemasAndFillDefaultValues } from '@mimir/common/mdf/MetaDataForm';
import type { SearchResultHit, LoadedItem } from '@mimir/common/dto/searchResultHit';
import { assert } from '@mimir/common/util/invariant';
import { getFieldDefinitionsForMetadata } from '@mimir/common/mdf/subtype';

export function createMosCompatibleItem(item: (SearchResultHit | LoadedItem), store: Store<State>): MosObjCompatibleItem {
  const allSchemas: MetaDataSchema[] = store.getters.mdfs;
  const { fieldMap } = getFieldDefinitionsForMetadata(item.metadata, allSchemas);

  let created: Date | undefined;
  if (item.metadata.formData[SystemDefaultField.CreatedOn]) {
    created = new Date(item.metadata.formData[SystemDefaultField.CreatedOn] as  string);
  }
  let changed: Date | undefined;
  if (item.modifiedOn) {
    changed = new Date(item.modifiedOn);
  }

  const itemType = item.itemType;
  assert(itemType !== 'folder', 'Did not expect folder');

  return {
    ...item,
    itemType,
    title: getItemSystemDefaultField(item, SystemDefaultField.Title),
    description: getItemSystemDefaultField(item, SystemDefaultField.Description),
    exportFriendlyMetadata: replaceIdWithFieldIdForSchemasAndFillDefaultValues(item.metadata, Object.values(fieldMap)),
    hasHighres: (item as LoadedItem).highRes !== undefined,
    created,
    changed,
  };
}
